export const homePageTranslationsFr = {
  homeNavLabel: 'Accueil',
  purchaseOrdersNavLabel: 'Commandes d’achat',
  notificationsLabel: 'Notifications',
  quickActionsLabel: 'Actions rapides',
  ordersTableLabel: 'Tableau des commandes',
  purchaseOrdersTableAriaLabel: 'Tableau des commandes d’achat',
  noOrdersFound: 'Aucune commande trouvée',
  timeNote: 'Toutes les heures sont affichées en heure du Pacifique (PT).',
  timeNotePT: 'Toutes les heures sont affichées en heure du Pacifique (PT).',
  timeNoteGMT: 'Toutes les heures sont affichées en heure de Greenwich (GMT).',
  refreshButtonLabel: 'Actualiser',
  refreshIconAlt: 'Icône d’actualisation',
  bannerTitle: 'CHiME agent',
  bannerSubtitle:
    'Ceci est votre espace de travail pour consulter, valider et gérer les commandes d’achat. Vérifiez régulièrement votre file d’attente pour suivre les demandes en attente.',
  notificationScheduledTitle: 'Maintenance planifiée',
  notificationScheduledText: 'Chime Agent ne sera pas disponible aujourd’hui de 22:00 à 23:00 PT.',
  notificationOrdersTitle: 'Impossible de charger toutes les commandes d’achat',
  notificationOrdersText: 'Certains éléments peuvent ne pas être affichés pour le moment. Veuillez actualiser la page ou réessayer plus tard.',
  tileMyTasksTitle: 'Mes tâches',
  tileMyTasksDescription: 'Consultez et gérez les commandes d’achat qui vous sont attribuées.',
  tileMyTasksLink: 'Accéder aux tâches',
  tileReportsTitle: 'Rapports',
  tileReportsDescription: 'Générez et consultez des rapports sur les activités liées aux commandes d’achat.',
  tileReportsLink: 'Voir les rapports',
  tileSettingsTitle: 'Paramètres',
  tileSettingsDescription: 'Personnalisez vos préférences et les paramètres de votre compte.',
  tileSettingsLink: 'Mettre à jour les paramètres',
  tableRequestDateHeader: 'Date et heure de la demande',
  tableShipToHeader: 'Destinataire',
  tablePoNumberHeader: 'N° BC',
  tableValidatedByHeader: 'Validé par',
  tableCommentHeader: 'Commentaire',
  tableStatusHeader: 'Statut',
  statusReadyForReview: 'Prête pour révision',
};
